import {useQuery} from "@tanstack/react-query";
import {fetchDELETE, fetchGET, fetchPOST, fetchPUT} from "./fetch";
import {useMyMutation} from "./mymutation";

const REACT_QUERY_ID_INSURANCESBEHAVIOURS = "insurancesbehaviours";
const BASE_URL = "/api/insurancesbehaviours";

const InsurancesBehaviourQueryConfig = {
    staleTime: 0,
    cacheTime: 1000 * 60 * 5,
}

export const INSURANCE_BEHAVIOUR_EMPTY = {
    title: "",
    description: "",
    type: '',
    fileCategories: {id:1,name:"test"},
    fileId: ""
};

export function useInsurancesBehaviours() {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_INSURANCESBEHAVIOURS],
        queryFn: async () => await fetchGET(BASE_URL),
        //onError: e => setError(e),
        ...InsurancesBehaviourQueryConfig
    });
    return {...result, insurancesBehaviours: result.data};
}


export function useInsuranceBehaviour(id) {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_INSURANCESBEHAVIOURS, id],
        queryFn: async () => id ? await fetchGET(`${BASE_URL}/${id}`) : {},
        //onError: e => setError(e),
        ...InsurancesBehaviourQueryConfig
    });
    return {...result, insuranceBehaviour: result.data};
}

export function useInsuranceBehaviourMutations() {
    async function createFunction(insuranceBehaviour) {
        if (!insuranceBehaviour) return;
        return await fetchPOST(BASE_URL, insuranceBehaviour, false);
    }

    async function editFunction(insuranceBehaviour) {
        if (!insuranceBehaviour) return;
        return await fetchPUT(`${BASE_URL}/${insuranceBehaviour.id}`, insuranceBehaviour);
    }

    async function editAddNewFiles(insuranceBehaviour) {
        if (!insuranceBehaviour) return;
        return await fetchPUT(`${BASE_URL}/${insuranceBehaviour.id}/files`, insuranceBehaviour.file);
    }

    async function deleteFunction(insuranceBehaviour) {
        return await fetchDELETE(`${BASE_URL}/${insuranceBehaviour.id}`)
    }

    return {
        createInsuranceBehaviour: useMyMutation(createFunction, REACT_QUERY_ID_INSURANCESBEHAVIOURS, insuranceBehaviour => `InsuranceBehaviour ${insuranceBehaviour.title} created`),
        editInsuranceBehaviour: useMyMutation(editFunction, REACT_QUERY_ID_INSURANCESBEHAVIOURS, insuranceBehaviour => `InsuranceBehaviour ${insuranceBehaviour.title} modified`),
        editAddNewFiles: useMyMutation(editAddNewFiles, REACT_QUERY_ID_INSURANCESBEHAVIOURS, insuranceBehaviour => `InsuranceBehaviour ${insuranceBehaviour.title} modified`),
        deleteInsuranceBehaviour: useMyMutation(deleteFunction, REACT_QUERY_ID_INSURANCESBEHAVIOURS, insuranceBehaviour => `InsuranceBehaviour ${insuranceBehaviour.title} deleted.`)
    };

}